import axiosInstance from "../axiosInstance";

export const getDashboardService = async () => {
    const response = await axiosInstance.get('/portfolio/get-dashboard');    
    return response.data;
};